import React, { useCallback, useState } from 'react'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

function MapLocation({
    coords,
    onChange,
}) {
    const [map, setMap] = useState(null)
    const [marker, setMarker] = useState(null)
    const [center, setCenter] = useState({ lat: 24.727627, lng: 46.663077 })
    const [zoom, setZoom] = useState(9)

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY
    })


    const onLoad = useCallback(function callback(map) {
        setMap(map)
        if(!!coords){
            setMarker({
                lat: coords?.latitude,
                lng: coords?.longitude
            })
            setCenter({
                lat: coords?.latitude,
                lng: coords?.longitude
            })
            setZoom(12)
        }
    }, [])

    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    const onMapClicked = (event) => {
        const latitude = event.latLng.lat()
        const longitude = event.latLng.lng()
        setMarker({
            lat: latitude,
            lng: longitude
        })
        onChange({ target: { name: "coords", value: { latitude, longitude } } })
    }

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={{
                width: "100%",
                height: '50vh'
            }}
            center={center}
            zoom={zoom}
            onLoad={onLoad}
            onUnmount={onUnmount}
            onClick={onMapClicked}
        >
            {!!marker && <Marker position={{ lat: marker.lat, lng: marker.lng }} />}
        </GoogleMap>
    ) : <></>
}

export default React.memo(MapLocation)